import { Fragment } from "react";

// Opt-in manuscript renderer. Page locators remain verbatim and each semicolon-
// separated reference remains independently reachable; legacy articles are untouched.
export const renderResearchText = (text, testId) => text.split(/(https?:\/\/[^\s)]+|\*\*[^*]+\*\*|\*[^*]+\*|\[\s*\d+[^\]]*\])/g).map((part, index) => {
  const key = `${testId}-inline-${index}`;
  if (/^https?:\/\//.test(part)) return <a key={key} className="article-external-link" href={part} target="_blank" rel="noreferrer" data-testid={`${key}-source`}>{part}</a>;
  if (part.startsWith("**") && part.endsWith("**")) return <strong key={key}>{renderResearchText(part.slice(2, -2), key)}</strong>;
  if (part.startsWith("*") && part.endsWith("*")) return <em key={key}>{renderResearchText(part.slice(1, -1), key)}</em>;
  if (/^\[\s*\d+[^\]]*\]$/.test(part)) return <sup className="article-citation" key={key} data-testid={`${key}-citation`}>[
    {part.slice(1, -1).split(/(;\s*)/).map((group, groupIndex) => {
      const reference = group.match(/^\s*(\d+)/);
      return reference ? <a href={`#reference-${reference[1]}`} key={`${key}-${groupIndex}`} data-testid={`${key}-reference-${reference[1]}`}>{group}</a> : <Fragment key={`${key}-${groupIndex}`}>{group}</Fragment>;
    })}
  ]</sup>;
  return part;
});